export enum OrderSource {
    'Bulk' = 0,
    'Individual' = 1,
    'Voucher' = 2,
    'Annual fee' = 3,
    'Cancellation' = 4,
    'Docs / IDV3' = 5,
}
